/**
 * SDK typing
 */
import { LIFFProfile } from './liff/liff.interface';
import {
  OpenParams,
  Session,
  TalariaProfile,
} from './talaria/talaria.interface';

declare global {
  interface Window {
    liff: any;
    _liff: any;
    Talaria: any;
    _Talaria: any;
  }
}

export type GenericFunction = (...args: any) => any;

export enum SdkApiName {
  INIT = 'init',
  GET_ACCESS_TOKEN = 'getAccessToken',
  IS_IN_CLIENT = 'isInClient',
  IS_LOGGED_IN = 'isLoggedIn',
  OPEN_WINDOW = 'openWindow',
  OPEN = 'open',
  CLOSE_WINDOW = 'closeWindow',
  LOGIN = 'login',
  READY = 'ready',
  GET_SESSION = 'getSession',
  GET_PROFILE = 'getProfile',
  GET_CONTEXT = 'getContext',
}

export type SdkApis = {
  [SdkApiName.INIT]: (params?: InitParams) => Promise<void>;
  [SdkApiName.GET_ACCESS_TOKEN]: () => Promise<string>;
  [SdkApiName.IS_IN_CLIENT]: () => Promise<boolean>;
  [SdkApiName.IS_LOGGED_IN]: () => Promise<boolean>;
  [SdkApiName.OPEN_WINDOW]: (params: OpenWindowParams) => Promise<void>;
  [SdkApiName.CLOSE_WINDOW]: () => void;
  [SdkApiName.GET_PROFILE]: () => Promise<LIFFProfile | TalariaProfile>;
  [SdkApiName.GET_CONTEXT]: () => Promise<any>;

  // LIFF only
  [SdkApiName.LOGIN]?: (params: LoginParams) => Promise<void>;
  [SdkApiName.READY]?: Promise<void>;

  // Talaria only
  [SdkApiName.GET_SESSION]?: () => Promise<Session>;
  [SdkApiName.OPEN]?: (params: OpenParams) => void;
};

export type SdkApiParameters<T extends SdkApiName> =
  Required<SdkApis>[T] extends GenericFunction
    ? Parameters<Required<SdkApis>[T]>[0]
    : never;

export type ExecuteParameters<T extends SdkApiName> = {
  name: T;
  params?: SdkApiParameters<T>;
};

export type ExecuteResponse<T extends SdkApiName> = Promise<
  Awaited<
    Required<SdkApis>[T] extends GenericFunction
      ? ReturnType<Required<SdkApis>[T]>
      : SdkApis[T]
  >
>;

/**
 * Method related typing
 */
//  we intentionally omit some Talaria params (type, packageName) and assume there are only two cases
//  (open window in IAB or EAB) need to be handled in order to make params consistent
export type OpenWindowParams = {
  url: string;
  external?: boolean;
};

// use for LIFF only
export type InitParams = {
  liffId: string;
};

export type LoginParams = {
  redirectUri?: string;
};

export type NormalizedProfile = {
  userId: string;
  displayName?: string;
  pictureUrl?: string;
  statusMessage?: string;
};
